<a
  class="grid grid-xs-column grid-nowrap align-items-start list-item"
  [routerLink]="getLink(item)"
  *ngIf="item"
>
  <span class="min-w-64 max-w-64 tag list-item-tag" *ngIf="item.hxid">
    {{ item.hxid }}
  </span>
  <div class="typography typography-headline typography-max-lines-4 word-break">
    {{ item.title }}
  </div>
</a>
